import { Close } from "@mui/icons-material";
import { Box, IconButton, LinearProgress, Modal, Typography } from "@mui/material";

import useScreenDimensions from "../hooks/useScreenDimensions";
import { muiModalStyles } from "./styles";

export default function MuiModalFrame({
  open,
  onClose,
  title,
  children,
  progress,
  width,
}) {
  const { windowWidth } = useScreenDimensions();
  const frameWidth = width ?? (windowWidth > 550 ? 550 : windowWidth - 50);

  return (
    <Modal open={Boolean(open)} onClose={onClose}>
      <Box
        sx={{
          ...muiModalStyles,
          width: frameWidth,
          maxHeight: "90vh",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            justifyContent: "space-between",
            display: "flex",
            flexDirection: "row",
            mb: 1,
            flexShrink: 0,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          <IconButton onClick={onClose} aria-label="Close">
            <Close />
          </IconButton>
        </Box>
        {typeof progress === "number" && (
          <LinearProgress variant="determinate" value={progress} />
        )}
        <Box sx={{ overflowY: "auto", minHeight: 0, flex: "1 1 auto" }}>
          {children}
        </Box>
      </Box>
    </Modal>
  );
}
